import Axios from "axios";
import { AxiosClient } from "../../utils/axios";
import { message as alertMessage } from "ant-design-vue";

export const state = () => ({
  studentScores: [],
  studentScoreNews: [],
  studentScoreLoading: false,
});

export const mutations = {
  SET_STUDENT_SCORE_LOADING(state, payload) {
    state.studentScoreLoading = payload;
  },
  SET_STUDENT_SCORES(state, payload) {
    state.studentScores = payload;
  },
  SET_STUDENT_SCORE_NEWS(state, payload) {
    state.studentScoreNews = payload;
  },
};

export const actions = {
  async getStudentScore({ commit }, { csv_file, sbd }) {
    commit("SET_STUDENT_SCORE_LOADING", true);
    try {
      const res = await AxiosClient.post(`/eduzone/api/student-score`, {
        csv_file,
        sbd,
      });
      commit("SET_STUDENT_SCORES", res.data);
    } catch (error) {
      commit("SET_STUDENT_SCORES", null);
      alertMessage.error(
        "Đã có lỗi xảy ra, vui lòng đợi trong giây lát và thử lại"
      );
    }
    commit("SET_STUDENT_SCORE_LOADING", false);
  },
  async getStudentScoreNews({ commit }, payload) {
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      const res = await Axios.get(`${domain}/eduzone/api/student-score/get-news`);
      // const res = await AxiosClient.post(
      //   `/eduzone/api/student-score/get-news`,
      //   payload
      // );
      commit("SET_STUDENT_SCORE_NEWS", res.data);
    } catch (error) {
      commit("SET_STUDENT_SCORE_NEWS", []);
      return error;
    }
  },
};
